import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const content = css`
  display: flex;
  flex-direction: column;
  min-block-size: 100vh;
  position: relative;
`

export const contentRu = css`
  min-block-size: calc(100vh - ${spacing(10)}); // минус высота нового хедера
`

export const root = css`
  flex: 1;
  position: relative;
  z-index: 5;

  &::after {
    background-color: ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.1)};
    filter: blur(${spacing(4)}); // 32px
    content: '';
    display: block;
    inset-block: 0;
    inset-inline: 0;
    max-inline-size: ${spacing(105)}; // 840px
    position: absolute;
    z-index: 6;
  }
`
export const formWrapper = css`
  inset-block: 0;
  inset-inline-start: ${spacing(2)};
  inline-size: ${spacing(100)};
  padding-block-start: ${spacing(15)}; // 120px
  padding-block-end: ${spacing(2)}; // 16px
  overflow: hidden;
  margin-block: ${spacing(2)};
  position: absolute;
  z-index: 1000;
`

export const formWrapperRu = css`
  padding-block-start: 0;
  margin-block: ${spacing(1)};
`

export const form = css`
  block-size: 100%;
  border-radius: ${spacing(3)};
  inline-size: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`
export const map = css`
  background-color: ${cssTheme.default.day.backgroundMinor};
  inset-block: 0;
  inset-inline: 0;
  position: fixed;
  cursor: pointer;
  z-index: 5;
`
